import React from 'react'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import PaginationComponent from './../../../../../components/pagination/pagination.component'
import { ClientReportsService } from './../../../../../services/client-reports.service'
import { ClientTicketService } from './../../../../../services/client-ticket.service'
import styled from 'styled-components'

const StyledSpan = styled.span`
	&:hover {
		.fa {
			transition: all 0.5s;
			color: #666 !important;
		}
	}
`

class PurchasePagination extends React.Component {
	componentWillReceiveProps(nextProps) {
		if (nextProps.forceReloadData !== this.props.forceReloadData) {
			this.refs.pagination.reload()
		}
	}
	render() {
		return (
			<PaginationComponent
				ref="pagination"
				headers={headers}
				rowsPerPage={10}
				params={this.props.params}
				getData={ClientReportsService.searchPurchases}
				renderRow={(rowData) => renderRow(rowData, this.props)}
			/>
		)
	}
}

function formatDateTime(date) {
	return date ? moment(date).format('DD/MM/YYYY HH:mm') : '-'
}

const CANCELED_STATUSES = ['Falhou', 'Cancelado', 'Reembolsado']

function renderRow(rowData, props) {
	return headers.map(({ key, align }) => {
		const isCanceled = CANCELED_STATUSES.includes(rowData.status)
		const showTicketModal = rowData.totalTickets > 0
		const showQrCode =
			rowData.status === 'Pendente' &&
			rowData.paymentType === 'Pix' &&
			!!rowData.pixImageQrCodeUrl
		const onClickRow = showTicketModal
			? () => {
					props
						.getPurchaseTickets(rowData.id, rowData.orderNumber)
						.then(props.openClientTicketModal)
			  }
			: null
		const onClickQrCode = () => {
			ClientTicketService.getPixQrCode(rowData.id).then((pixImageQrCode) => {
				props.openQrCodeModal({
					pixImageQrCode,
					pixValidity: rowData.pixValidity,
				})
			})
		}

		switch (key) {
			case 'dateCreated':
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span>{formatDateTime(rowData[key])}</span>
					</td>
				)
			case 'paymentType':
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span>{rowData.paymentType}</span>
					</td>
				)
			case keys.STATUS:
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span title={rowData.status} className={isCanceled ? 'danger' : ''}>
							{rowData.status}
						</span>
					</td>
				)
			case keys.VALUE: {
				const valorFormatado = Number(rowData.value).toLocaleString('pt-BR', {
					style: 'currency',
					currency: 'BRL',
				})

				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span title={valorFormatado}>{valorFormatado}</span>
					</td>
				)
			}
			case keys.ACTIONS:
				return (
					<td key={key} align={align}>
						{showQrCode && (
							<StyledSpan
								title="Exibir QR Code para pagamento"
								onClick={onClickQrCode}>
								<FontAwesome name="qrcode" />
							</StyledSpan>
						)}
						{showTicketModal && (
							<StyledSpan
								style={{ marginLeft: showQrCode ? '1em' : 0 }}
								title="Visualizar detalhes da viagem"
								onClick={onClickRow}>
								<FontAwesome name="ticket" />
							</StyledSpan>
						)}
					</td>
				)
			default:
				return (
					<td key={key} align={align} onClick={onClickRow}>
						<span title={rowData[key]}>{rowData[key]}</span>
					</td>
				)
		}
	})
}

const keys = {
	VALUE: 'value',
	STATUS: 'status',
	ACTIONS: 'actions',
}

const headers = [
	{ header: 'Data da compra', key: 'dateCreated', align: 'center' },
	{ header: 'Pedido', key: 'orderNumber', align: 'center' },
	{ header: 'Meio de pagamento', key: 'paymentType', align: 'center' },
	{ header: 'Valor', key: keys.VALUE, align: 'right' },
	{ header: 'Situação', key: keys.STATUS },
	{ header: 'Ações', key: keys.ACTIONS, align: 'right' },
]

export default PurchasePagination
